module.exports = __webpack_public_path__ + "img/title_6.94a5c459.png";